import { ZendeskHomePage } from './ZendeskHomePage'

export const ZendeskHomeRoutes = () => {
  return <ZendeskHomePage />
}
